import { reactive, toRefs } from "vue"

const state = reactive({
    tax: 0,
})

function setTax(tax) {
    state.tax = tax
}

export function useAccountingStore() {
    return {
        ...toRefs(state),
        setTax
    }
}